let authCheck = () => true;

export default function asyncActionCreator (options) {

	const ACTION          = options.name;
	const ACTION_COMPLETE = options.name+'_COMPLETE';
	const ACTION_FAILED   = options.name+'_FAILED';

	function loadActionCreator () {
		const params = [].slice.call(arguments);
		return {
			type: ACTION,
			params,
		};
	}

	function loadSuccessActionCreator (data, params) {
		return {
			type: ACTION_COMPLETE,
			data,
			params
		};
	}

	function loadFailActionCreator (error, params) {
		return {
			type: ACTION_FAILED,
			error,
			params
		};
	}

	function fetch () {
		const args = [].slice.call(arguments);

		if (options.validate && !options.validate.apply(this, args)) {
			return loadFailActionCreator({ message: 'validation failed' }, args);
		}

		if (options.needsAuth && !authCheck()) {
			return () => {
				return Promise.reject(loadFailActionCreator({ message: 'Authorization failed' }, args));
			}
		}

		return (dispatch, getState) => {
			dispatch(loadActionCreator.apply(null, args));
			return options.action.apply(null, args)
				.then (data  => {
					dispatch(loadSuccessActionCreator(data, args));
					if (options.chain) {
						if (typeof options.chain === 'function') {
							dispatch(options.chain.apply(null, args));
						} else if (options.chain.forEach) {
							options.chain.forEach(fn => dispatch(fn.apply(null, args)));
						}
					}
					return data;
				})
				.catch(error => {
					dispatch(loadFailActionCreator(error, args));
					throw error;
				});
		};
	}

	fetch.ACTION          = ACTION;
	fetch.ACTION_COMPLETE = ACTION_COMPLETE;
	fetch.ACTION_FAILED   = ACTION_FAILED;

	return fetch;

};

export function setAuthCheck(fn) {
	authCheck = fn;
}


// WEBPACK FOOTER //
// ./src/frontend-standard-library/modules-react/Base/ActionCreator/asyncActionCreator.js